import { odinClient } from "@/config/client"

export interface NextQuestionFlashcard {
  index: number
  question: string
  answer: string
}

export interface FlashcardActivity {
  id: string
  total: number
  more: boolean
  current: number
  next: NextQuestionFlashcard
}

export interface CreateStudySessionResponse {
  description: FlashcardActivity
}

export interface Params {
  id: string
  body: { userActivityId: string }
}

export function create({ id, body }: Params) {
  return odinClient.post<CreateStudySessionResponse, Params["body"]>(
    `/v1/activities/${id}/flashcards/study-session`,
    body,
  )
}
